import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHackadayComponent } from './simple-icons-hackaday.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHackadayComponent ],
    exports:      [ SimpleIconsHackadayComponent ],
    bootstrap:    []
})
export class SimpleIconsHackadayModule {}
